export default __webpack_public_path__ + "0fe9ca9e8408b7a8cd6a368a99f667ab.png";